module.exports = __webpack_public_path__ + "static/img/index_bk2_icon.3cb6bc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index_bk2_icon.png
// module id = sJuh
// module chunks = 4